import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useContext } from 'react';
import { AppContext } from '../main';


const CustomerReviews = (props) => {
    const {
        handleEditItem
    } = props
    const { appState
    } = useContext(AppContext);
    const {
        reviews = [],
        // reviewsHeader = {},
        editMode = false
    } = appState

    // console.log('ssss', reviews)

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="subtitle mb20">{reviews?.title}</div>
                        <h2 className="wow fadeInUp">{reviews?.subtitle}</h2>
                        <div className="spacer-20"></div>

                    </div>
                </div>
            </div>
            <Swiper
                className="smallslider"
                modules={[Pagination]}
                spaceBetween={20}
                slidesPerView="auto"
                pagination={{ clickable: true }}
                centeredSlides
                loop
                slideToClickedSlide
            >
                {reviews.posts?.map((review) => (
                    <SwiperSlide key={review.id}>
                        <div className="swiper-inner">
                            <div className="de_testi type-2">
                                {/* {editMode && <button className="d-label"
                                    style={{
                                        display: 'flex',
                                        // marginBottom: 200,
                                        // position: 'absolute',
                                        zIndex: 5,

                                    }}
                                    onClick={() => {
                                        handleEditItem({
                                            section: 'reviews',
                                            config: review
                                        })
                                    }}
                                >Edit</button>} */}
                                <blockquote>
                                    <div className="de-rating-ext">
                                        <span className="d-stars">
                                            {[...Array(5)].map((_, i) => (
                                                <i key={i} className="fa fa-star"></i>
                                            ))}
                                        </span>
                                    </div>
                                    <p>&quot;{review.text}&quot;</p>
                                    <div className="de_testi_by">
                                        <img alt={review.name} src={review.image} /> <span>{review.name}</span>
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
};

export default CustomerReviews;